import { post, put, get } from "../../helpers/apihelpers";

export const CreateDistributorSubscriptionService=async(data)=>{
    try {
        const result = await post(`api/admin/distributor_subscribe_points/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateDistributorSubscriptionService=async(data,id)=>{
    try {
        const result = await put(`api/admin/distributor_subscribe_points/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetDistributorSubscriptionService = async ()=>{
  try {
    const result = await get(`api/admin/distributor_subscribe_points/get`);
    return result;
  } catch (err) {
    return err.response;
  }
}